import React, { useContext } from 'react'
import { Paper, Container, Divider, Tooltip } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { ReactComponent as ShieldSvg } from '../../assets/shield_with_v.svg'
import { ReactComponent as RenewSvg } from '../../assets/renew.svg'
import { ReactComponent as RenewSvgGray } from '../../assets/renew_powderblue.svg'
import './PolicySummary.scss'
import { InsurancePurchaseContextStore } from '../../context/InsuracePurchaseContext'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import {
  liabilityLimitPretty,
  billingPeriodPretty,
  isInFlow,
  KPretty,
  currencySymbol,
} from '../../services/utils'
import dayjs from 'dayjs'
import { SessionContextStore } from '../../context/SessionContext'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import { COUNTRIES } from '../../Constants'
import LocalizationService from '../../services/LocalizationService'
import { COVERAGE_TYPES } from '../../models/insurance-models/CoverageType'
import { WorldWideOption } from '../../models/insurance-models/WorldWideOption'
import { useLocation, useParams } from 'react-router-dom'
import { AutoRenewBeforePurchaseSection } from '../PolicyManagement/PolicyView/PolicyDetailSections/AviationCustomizeAutoRenewSection'

export const PolicySummary = (props) => {
  const insuranceContext = useContext(InsurancePurchaseContextStore)
  const sessionContext = useContext(SessionContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const location = useLocation()

  let hidePremiums = offersContext.violations.length > 0

  let title = billingPeriodPretty(insuranceContext.selectedOption.billingPeriod)

  const coverageBreakdownOrder = [
    'bodilyInjuryLiability',
    'aircraftDamageLiability',
    'deductibleReimbursement',
    'medicalPayments',
  ]

  return (
    <React.Fragment>
      <Paper elevation={3} className="policy-summary-container">
        <div className="policy-summary-headline">
          <FlexView className="space-between">
            <FlexView vAlignContent={'center'}>
              <ShieldSvg className="white-svg-path" />
              <div className="white text-body bold margin-left-6">
                Your Policy
              </div>
            </FlexView>
            <div>
              <div className="text-tiny white">Start date</div>
              <div className="text-tiny white">
                {dayjs(offersContext.offerCart.period.startDate).format(
                  FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)
                )}
              </div>
            </div>
          </FlexView>
        </div>
        <Container className="margin-top-basic">
          <FlexView className="space-between">
            <div className="black text-tiny">Insured:</div>
            <div className="black text-tiny">
              {sessionContext.user.firstName} {sessionContext.user.lastName}
            </div>
          </FlexView>
          <Divider />

          <div className="blak text-body margin-bottom-small bold">
            Aircraft types
          </div>
          <FlexView className="margin-top-small">
            {sessionContext.user.singleEngineLand && (
              <div className="black text-tiny">SEL</div>
            )}
            {sessionContext.user.multiEngineLand && (
              <div className="black text-tiny">, MEL</div>
            )}
            {sessionContext.user.singleEngineSeaplane && (
              <div className="black text-tiny margin-right-3">, SES</div>
            )}
          </FlexView>

          <Divider />
          <div className="blak text-body margin-bottom-small bold">
            Coverages
          </div>
          {offersContext.pricebreakdown.vehicleCoveragePrices &&
            Object.keys(offersContext.pricebreakdown.vehicleCoveragePrices).map(
              (idKey) => {
                return (
                  offersContext.pricebreakdown.vehicleCoveragePrices[idKey]
                    .coveragePrices &&
                  Object.keys(
                    offersContext.pricebreakdown.vehicleCoveragePrices[idKey]
                      .coveragePrices
                  )
                    .sort((a, b) =>
                      coverageBreakdownOrder.indexOf(a) <
                      coverageBreakdownOrder.indexOf(b)
                        ? -1
                        : 1
                    )
                    .map((cove) => (
                      <FlexView className="space-between margin-top-small">
                        <FlexView>
                          <div className="black text-tiny margin-right-3">
                            {
                              offersContext.pricebreakdown
                                .vehicleCoveragePrices[idKey]['coveragePrices'][
                                cove
                              ].title
                            }{' '}
                            {
                              offersContext.pricebreakdown
                                .vehicleCoveragePrices[idKey]['coveragePrices'][
                                cove
                              ].liability
                            }
                          </div>
                        </FlexView>
                        {!hidePremiums && (
                          <div className="black text-tiny">
                            {currencySymbol()}
                            {offersContext.pricebreakdown.vehicleCoveragePrices[
                              idKey
                            ]['coveragePrices'][cove].price.toFixed(2)}
                          </div>
                        )}
                      </FlexView>
                    ))
                )
              }
            )}

          <Divider />

          {offersContext.pricebreakdown.tax > 0 && (
            <FlexView className="space-between margin-top-small margin-bottom-small">
              <div className="black text-tiny">
                {LocalizationService.STRINGS.tax}
              </div>
              {!hidePremiums && (
                <div className="black text-tiny">
                  {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                  {offersContext.pricebreakdown.tax}
                </div>
              )}
            </FlexView>
          )}

          {offersContext.pricebreakdown &&
            offersContext.pricebreakdown.price && (
              <>
                <FlexView className="space-between margin-top-small">
                  <div className="blue bolder text-body">Total Price:</div>
                  {!hidePremiums && (
                    <div className="blue bolder text-body">
                      {currencySymbol()}
                      {offersContext.pricebreakdown.price.toFixed(2)}
                    </div>
                  )}
                </FlexView>
              </>
            )}

          <AutoRenewBeforePurchaseSection location={location} />

          {props.mobileExtension && (
            <div className="margin-top-basic">{props.mobileExtension}</div>
          )}
        </Container>
      </Paper>
    </React.Fragment>
  )
}
